"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

/**
 * Full-screen blocking overlay shown briefly while the app reloads onto a new
 * deployment (post-deploy version skew recovery). The backdrop intercepts all
 * input so the user can't interact with the stale UI mid-reload.
 */
export function UpdateToast(t0) {
  const $ = _c(10);
  const {
    className
  } = t0;
  const t = useTranslations("common");
  let t1;
  if ($[0] !== className) {
    t1 = cn("fixed inset-0 z-[3000] flex items-center justify-center bg-white/80 backdrop-blur-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Loader2 className="h-5 w-5 animate-spin" data-sentry-element="Loader2" data-sentry-source-file="UpdateToast.tsx" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("updatingVersion");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex items-center gap-3 whitespace-nowrap rounded-full bg-zinc-900/95 text-white text-sm px-5 py-3 shadow-2xl">{t2}<span>{t3}</span></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div role="status" aria-live="assertive" data-testid="update-toast" className={t1} data-sentry-component="UpdateToast" data-sentry-source-file="UpdateToast.tsx">{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}